<!-- NOTE: Currently this is a modified Button Text Component (from CMS) -->
<!-- TODO: After PTO, properly convert this to a FLUX Button Component -->
<script setup>
import { watch } from 'vue';

// // FLUX Button Shapes
// //   - Primary: Pill badge
// //   - Secondary: Rounded rectangle

// // FLUX Button Types
// //   - Solid: Color fill, light text, color border
// //   - White: Light fill, dark text, soft border
// //   - White Blue: Light fill, color text, soft border
// //   - Outline: Light fill, color text, color border
// //   - Overlay: Dark transparent fill, light text, Dark transparent border

const props = defineProps({
  // // @Params
  // // buttonCopy: Any String
  // // buttonShape: 'pr' = Primary (default), 'sc' = Secondary
  // // buttonType: 'sl' = Solid (default), 'wh' = White, 'wb' = White Blue,
  // // 'ot' = Outline, 'ov' = Overlay
  // // buttonCase: 'nr' = Normal (default), 'cp' = Capitalized,
  // // 'up' = Uppercase, 'lw' = Lowercase
  // // isDisabled: false = Active (default), true = Inactive
  buttonCopy: {
    type: String,
    default: 'Click Here',
  },
  buttonFallbackCopy: {
    type: String,
    default: 'Click Here',
  },
  buttonShape: {
    type: String,
    default: 'pr',
  },
  buttonType: {
    type: String,
    default: 'sl',
  },
  buttonCase: {
    type: String,
    default: 'nr',
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['buttonHit', 'copyCheckEmitted']);

// // FluxButton setup functions

const setShape = () => {
  let buttonTextShapeResults = 'bt-primary';

  if (props.buttonShape === 'sc') {
    buttonTextShapeResults = 'bt-secondary';
  }

  return buttonTextShapeResults;
};

const setType = () => {
  const buttonTextShapeCapture = setShape();

  let buttonTextTypeResults = `${buttonTextShapeCapture}__solid`;

  if (props.buttonType === 'wh') {
    buttonTextTypeResults = `${buttonTextShapeCapture}__white`;
  } else if (props.buttonType === 'wb') {
    buttonTextTypeResults = `${buttonTextShapeCapture}__white-blue`;
  } else if (props.buttonType === 'ot') {
    buttonTextTypeResults = `${buttonTextShapeCapture}__outline`;
  } else if (props.buttonType === 'ov') {
    buttonTextTypeResults = `${buttonTextShapeCapture}__overlay`;
  }

  return buttonTextTypeResults;
};

const setLetterCase = () => {
  let buttonTextCaseResults = '';

  if (props.buttonCase === 'cp') {
    buttonTextCaseResults = 'letter-case-capital';
  } else if (props.buttonCase === 'up') {
    buttonTextCaseResults = 'letter-case-upper';
  } else if (props.buttonCase === 'lw') {
    buttonTextCaseResults = 'letter-case-lower';
  }

  return buttonTextCaseResults;
};

// // FluxButton handler functions

const buttonClickHandler = (e) => {
  emit('buttonHit', e);
};

const copyComparisonHandler = () => {
  emit('copyCheckEmitted', props.buttonFallbackCopy);
};

// // FluxButton watchers

watch(
  () => props.buttonCopy,
  (buttonCopyNewVal) => {
    // console.log(`buttonCopyNewVal !== props.buttonFallbackCopy: ${buttonCopyNewVal !== props.buttonFallbackCopy}`);

    if (buttonCopyNewVal !== props.buttonFallbackCopy) {
      copyComparisonHandler();
    } else {
      setTimeout(() => {
        // console.log('Slight delay because default copy is in use.');

        copyComparisonHandler();
      }, 1000);
    }
  },
  {
    deep: true,
    immediate: true,
  },
);
</script>

<template>
  <button
    class="button-text"
    :class="`${setShape()} ${setType()} ${setLetterCase()}`"
    type="button"
    :disabled="props.isDisabled"
    @click="buttonClickHandler"
  >
    <span class="button-text__copy">{{ props.buttonCopy }}</span>
  </button>
</template>

<style scoped lang="scss">
@use './fluxbutton.scss';
</style>
